<template>
    <div class="p-fluid p-grid">
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart2"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart7"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart3"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart4"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart6"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart5"></canvas>
      </div>
      
    </div>
</template>
  
<script>
import Chart from 'chart.js'

export default {
  name: 'Chart',
  data() {
    return {
      chartData: null,
      planetChartData1: null,
      planetChartData2: null
    }
  },
  mounted() {
    this.createChart()
  },
  methods: {
    createChart() {
      this.planetChartData()
      this.planetChartDataSales()
      this.planetChartDataCashIn()
      this.planetChartDataCashOut()
      this.planetChartDataPurchaseAndSales()
      this.planetChartDataCashInOut()
      // this.planetChartDataProfitAndLoss()
    },
    async planetChartData() {
      let resp = await this.$store.dispatch('loadPurchaseBar')
      const ctx = document.getElementById('planet-chart')
      /* eslint-disable no-new */
      new Chart(ctx, { type: 'bar', data: resp, options: '' })
      return resp
    },
    async planetChartDataSales() {
      let resp = await this.$store.dispatch('loadSalesBar')
      const ctx1 = document.getElementById('planet-chart2')
      new Chart(ctx1, { type: 'bar', data: resp, options: '' })
      return resp
    },
    async planetChartDataCashIn() {
      let resp = await this.$store.dispatch('loadCashInBar')
      const ctx2 = document.getElementById('planet-chart3')
      new Chart(ctx2, { type: 'bar', data: resp, options: '' })
      return resp
    },
    async planetChartDataCashInOut() {
      let resp = await this.$store.dispatch('loadCashInOutBar')
      const ctx2 = document.getElementById('planet-chart5')
      new Chart(ctx2, { type: 'bar', data: resp, options: '' })
      return resp
    },
    async planetChartDataCashOut() {
      let resp = await this.$store.dispatch('loadCashOutBar')
      const ctx3 = document.getElementById('planet-chart4')
      new Chart(ctx3, { type: 'bar', data: resp, options: '' })
      return resp
    },
    // async planetChartDataProfitAndLoss() {
    //   debugger
    //   let resp = await this.$store.dispatch('loadProfitLossMonthly')
    //   debugger
    //   const ctx4 = document.getElementById('planet-chart6')
    //   new Chart(ctx4, { type: 'bar', data: resp, options: '' })
    //   return resp
    // },
    async planetChartDataPurchaseAndSales() {
      let resp = await this.$store.dispatch('loadPurchaseSalesBar')
      const ctx5 = document.getElementById('planet-chart7')
      new Chart(ctx5, { type: 'bar', data: resp, options: '' })
      return resp
    }
  }
}
</script>



// WEBPACK FOOTER //
// Chart.vue?5822bb04